import React from 'react'
import OrganizationLogo from './OrganizationLogo'
import { usePublicOrganization } from '../hooks/usePublicOrganization'
import useQueryParam from '../hooks/useQueryParams';

export default function OrganizationPublicBrand() {
    const { orgId } = useQueryParam();
    const org = usePublicOrganization({ orgId })
    const logoUrl = org?.logo

    return (
        <div className='center gap-2'>
            <OrganizationLogo logo={logoUrl} size='sm' />
            <h3>{org?.name}</h3>
        </div>
    )
}
